import React from 'react'

import { HeadingMedium, HeadingSmall, BodyText, Table, Label } from '@pb/components'
import { formatCurrency, formatDate } from '@pb/utils'

import styles from './MonthlyInvoiceDetails.scss'

const MonthlyInvoiceDetails: React.FC<any> = ({
  servicingCharges = [],
  amountLeftToPay,
  dueDate,
}) => (
  <Table className={styles.container}>
    <tbody>
      {servicingCharges.map(({ label, amount }) => (
        <tr key={`servicingCharge${amount}`}>
          <BodyText Tag="td">{label}</BodyText>
          <BodyText Tag="td" right>
            {formatCurrency(amount / 100)}
          </BodyText>
        </tr>
      ))}
      {amountLeftToPay >= 0 && (
        <tr>
          <HeadingSmall Tag="td">
            <Label copyKey="omni.details.todo.section.purchases.section.total.amount" />
          </HeadingSmall>
          <HeadingSmall Tag="td" right>
            {formatCurrency(amountLeftToPay / 100)}
          </HeadingSmall>
        </tr>
      )}
      <tr>
        {/* @ts-expect-error ts-migrate(2322) FIXME: Type '{ children: Element; colSpan: string; Tag: s... Remove this comment to see the full error message */}
        <HeadingMedium colSpan="2" Tag="td" className={styles.paymentInformationHeading}>
          <Label copyKey="omni.details.todo.section.purchases.section.payment.info" />
        </HeadingMedium>
      </tr>
      <tr>
        <BodyText Tag="td">
          <Label copyKey="omni.details.todo.section.purchases.section.payment.date" />
        </BodyText>
        <BodyText Tag="td" right>
          {formatDate(dueDate)}
        </BodyText>
      </tr>
    </tbody>
  </Table>
)

export default MonthlyInvoiceDetails
